/**
 * Public surface of the report export module.
 *
 * jsPDF and the embedded fonts are pulled in through a dynamic import so none
 * of it lands in the report bundle — the chunk downloads the first time
 * somebody actually exports.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { buildReportDoc } from './build-report-doc';
export { buildReportDoc } from './build-report-doc';
export { interviewDateLabel } from './date-label';
const saveBlob = (blob, fileName) => {
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
};
/** Builds, renders and downloads a report PDF. Rejects if rendering fails. */
export const exportReportPdf = (vm, variant, _a) => __awaiter(void 0, void 0, void 0, function* () {
    var { fileName } = _a, buildOptions = __rest(_a, ["fileName"]);
    const spec = buildReportDoc(vm, variant, buildOptions);
    const { renderDocSpecToPdf } = yield import('./render-pdf');
    saveBlob(yield renderDocSpecToPdf(spec), fileName);
});
